var exports = {
  "PM": "SetupBrandingStep.module__step___TDhmcl",
  "wx": "SetupBrandingStep.module__header___TDhmcl",
  "DD": "SetupBrandingStep.module__title___TDhmcl",
  "rf": "SetupBrandingStep.module__body___TDhmcl",
  "RG": "SetupBrandingStep.module__previewPane___TDhmcl",
  "Sx": "SetupBrandingStep.module__fieldsPane___TDhmcl",
  "OA": "SetupBrandingStep.module__fields___TDhmcl",
  "Os": "SetupBrandingStep.module__group___TDhmcl",
  "x_": "SetupBrandingStep.module__groupHeader___TDhmcl",
  "Yg": "SetupBrandingStep.module__groupHeading___TDhmcl",
  "v4": "SetupBrandingStep.module__presets___TDhmcl",
  "IS": "SetupBrandingStep.module__preset___TDhmcl",
  "K9": "SetupBrandingStep.module__presetSelected___TDhmcl",
  "H": "SetupBrandingStep.module__colorHelp___TDhmcl",
  "N4": "SetupBrandingStep.module__note___TDhmcl",
  "rM": "SetupBrandingStep.module__noteWarning___TDhmcl",
  "V3": "SetupBrandingStep.module__assetError___TDhmcl",
  "tM": "SetupBrandingStep.module__assetWarning___TDhmcl",
  "hH": "SetupBrandingStep.module__stepError___TDhmcl",
  "Re": "SetupBrandingStep.module__assetRow___TDhmcl",
  "UG": "SetupBrandingStep.module__assetRowEmpty___TDhmcl",
  "$3": "SetupBrandingStep.module__assetRowError___TDhmcl",
  "Ut": "SetupBrandingStep.module__assetRowDragging___TDhmcl",
  "xn": "SetupBrandingStep.module__thumbnail___TDhmcl",
  "YF": "SetupBrandingStep.module__resetHidden___TDhmcl",
  "_j": "SetupBrandingStep.module__thumbnailCover___TDhmcl",
  "kt": "SetupBrandingStep.module__thumbnailEmpty___TDhmcl",
  "vo": "SetupBrandingStep.module__assetBody___TDhmcl",
  "NR": "SetupBrandingStep.module__assetLabel___TDhmcl",
  "an": "SetupBrandingStep.module__assetHint___TDhmcl",
  "iD": "SetupBrandingStep.module__helpToggle___TDhmcl",
  "PE": "SetupBrandingStep.module__helpToggleIcon___TDhmcl",
  "yj": "SetupBrandingStep.module__help___TDhmcl",
  "m$": "SetupBrandingStep.module__helpOpen___TDhmcl",
  "MA": "SetupBrandingStep.module__assetMeta___TDhmcl",
  "F8": "SetupBrandingStep.module__assetStatus___TDhmcl",
  "G$": "SetupBrandingStep.module__assetActions___TDhmcl",
};

module.exports = exports;
